





































import { Component, Vue, Watch } from 'vue-property-decorator';
import { IProxyError, IProxyUserBanCreate } from '@/interfaces';
import {
  dispatchCreateProxyUserBan,
  readProxyErrors,
  dispatchGetProxyErrors,
  readServices,
  dispatchGetServices,
} from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import { ValidationProvider } from 'vee-validate';
import { commitSetShowProgress } from '@/store/main/accessors';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
  },
})
export default class CreateProxyError extends Vue {
  public valid = false;
  public phone: string = '';
  public service: string = '';
  public proxyErrorDescription: string = '';
  public servicesList = [];
  public proxyErrorsList = [];
  public services;
  public proxyErrors;
  public setProxyError = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    await dispatchGetServices(this.$store);
    this.services = new Map<string, number>(
      readServices(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    this.servicesList = Array.from(this.services.keys());
    this.reset();
  }

  public reset() {
    this.phone = '';
    this.service = '';
    this.proxyErrorDescription = '';
    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const proxyError = this.proxyErrors.get(this.proxyErrorDescription);
      const expirationDt = new Date();
      expirationDt.setSeconds(expirationDt.getSeconds() + proxyError.user_ban_duration);
      const createdProxyUserBan: IProxyUserBanCreate = {
        phone: this.phone,
        service_id: proxyError.service_id,
        proxy_error_id: proxyError.id,
        expiration_dt: expirationDt,
        additional_info: null,
        is_permanent: false,
        expiration_minutes: proxyError.user_ban_duration,
      };
      const result = await dispatchCreateProxyUserBan(this.$store, createdProxyUserBan);
      if (result) {
        this.$router.push('/main/admin/proxy_user_bans');
      }
    }
  }

  @Watch('service')
  public async setSendersList() {
    const loadingNotification = { content: 'loading proxy errors', showProgress: true };
    commitSetShowProgress(this.$store, true);
    this.proxyErrorDescription = '';
    if (this.service) {
      await dispatchGetProxyErrors(this.$store, { serviceId: this.services.get(this.service) });
      this.proxyErrors = new Map<string, IProxyError>(
        readProxyErrors(this.$store).map(
          (item) =>
            [`${item.error_description} (${item.status_code}, ${item.error_code})`, item] as [string, IProxyError],
        ),
      );
      this.proxyErrorsList = Array.from(this.proxyErrors.keys());
      this.setProxyError = true;
    } else {
      this.proxyErrors = {};
      this.proxyErrorsList = [];
    }
    commitSetShowProgress(this.$store, false);
    this.$refs.observer.reset();
  }
}
